import React, { useContext } from 'react';
import cn from 'classnames';
import { Button } from '@alfalab/core-components-button/esm';
import { Spinner } from '@alfalab/core-components-spinner/esm';
import { Text } from '@alfalab/core-components-typography/esm';
import { ConfirmationContext } from './context.js';
import { formatMsAsMinutes } from './utils.js';

var styles = {"component":"confirmation__component_16d1d","phone":"confirmation__phone_16d1d","typographyTheme":"confirmation__typographyTheme_16d1d","typographyThemeMobile":"confirmation__typographyThemeMobile_16d1d","compact":"confirmation__compact_16d1d","loaderWrap":"confirmation__loaderWrap_16d1d","left":"confirmation__left_16d1d","center":"confirmation__center_16d1d","codeInput":"confirmation__codeInput_16d1d","smsBtn":"confirmation__smsBtn_16d1d","smsComeLink":"confirmation__smsComeLink_16d1d","countdownContainer":"confirmation__countdownContainer_16d1d","countdownMobile":"confirmation__countdownMobile_16d1d","countdownLoaderMobile":"confirmation__countdownLoaderMobile_16d1d","getCodeButton":"confirmation__getCodeButton_16d1d","getCodeButtonMobile":"confirmation__getCodeButtonMobile_16d1d","containerInput":"confirmation__containerInput_16d1d"};
require('./components/screens/initial/index.css')

var CountdownSection = function (_a) {
    var _b, _c;
    var codeSendHintVisible = _a.codeSendHintVisible, timePassed = _a.timePassed, processing = _a.processing, mobile = _a.mobile, handleSmsRetryClick = _a.handleSmsRetryClick;
    var _d = useContext(ConfirmationContext), state = _d.state, texts = _d.texts, timeLeft = _d.timeLeft, blockSmsRetry = _d.blockSmsRetry, breakpoint = _d.breakpoint, client = _d.client;
    var renderText = function (text) {
        var _a;
        return (React.createElement(Text, { className: cn(styles.countdownContainer, (_a = {},
                _a[styles.countdownMobile] = mobile,
                _a[styles.typographyTheme] = !mobile,
                _a)), view: mobile ? 'primary-small' : 'primary-medium', tag: 'div' }, text));
    };
    if (codeSendHintVisible)
        return renderText(texts.codeSended);
    if (processing) {
        return (React.createElement("div", { className: cn(styles.loaderWrap, styles.countdownContainer, (_b = {},
                _b[styles.countdownLoaderMobile] = mobile,
                _b[styles.typographyTheme] = !mobile,
                _b)) },
            React.createElement(Spinner, { preset: 24, visible: true }),
            React.createElement("span", { className: styles.loaderText }, state === 'CODE_CHECKING' ? texts.codeChecking : texts.codeSending)));
    }
    if (blockSmsRetry)
        return renderText(texts.noAttemptsLeft);
    if (timePassed) {
        return (React.createElement(Button, { size: mobile ? 'xs' : 'xxs', view: 'secondary', onClick: handleSmsRetryClick, className: cn(styles.getCodeButton, (_c = {}, _c[styles.getCodeButtonMobile] = mobile, _c)), breakpoint: breakpoint, client: client }, texts.buttonRetry));
    }
    return renderText("".concat(texts.countdown, " ").concat(formatMsAsMinutes(timeLeft)));
};

export { CountdownSection as C, styles as s };
